module.exports = __webpack_public_path__ + "static/media/icon_c.296fa274.svg";